import { render, staticRenderFns } from "./BorrowingPage_Community.vue?vue&type=template&id=aceb272e&scoped=true&"
import script from "./BorrowingPage_Community.vue?vue&type=script&lang=js&"
export * from "./BorrowingPage_Community.vue?vue&type=script&lang=js&"
import style0 from "./BorrowingPage_Community.vue?vue&type=style&index=0&id=aceb272e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceb272e",
  null
  
)

export default component.exports